/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Valuator } from '../models/valuator';

@Injectable({
  providedIn: 'root',
})
export class ValuatorsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getValuatorById
   */
  static readonly GetValuatorByIdPath = '/api/v1/Valuators/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuatorById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuatorById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.getValuatorById$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValuatorById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Json$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Valuator>> {

    const rb = new RequestBuilder(this.rootUrl, ValuatorsService.GetValuatorByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Valuator>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValuatorById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValuatorById$Json(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Valuator> {

    return this.getValuatorById$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<Valuator>) => r.body as Valuator)
    );
  }

}
